import * as React from 'react'
import {
  createExternalDemoDistrict,
  fetchExternalDemoDistrict
} from '@frontrow/console/src/helpers/api-demo-district'
import {Button} from '@frontrow/console/src/components/button'
import {type PolyfilledEvent} from '@frontrow/console/src/polyfills'

import {type DemoDistrictT, parseDemoDistrict} from '@frontrow/console/src/models/demo-district'
import DemoDistrictPage from '@frontrow/console/src/components/pages/demo-districts-page/demo-district-page'
import {
  demoAccountSearch,
  findCreateButton,
  formInline,
  formInput
} from './demo-district-management.module.scss'

export default function DemoDistrictManagement(): React.ReactElement {
  const [isFetching, setIsFetching] = React.useState<boolean>(false)
  const [email, setEmail] = React.useState<string>('')
  const [activeSearchEmail, setActiveSearchEmail] = React.useState<string>('')
  const [message, setMessage] = React.useState<React.ReactNode>(null)
  const [demoDistrict, setDemoDistrict] = React.useState<DemoDistrictT | null>(null)

  const onSubmit = (e: PolyfilledEvent) => {
    e.preventDefault()
    setActiveSearchEmail(email)
  }

  const demoDistrictStatus =
    demoDistrict === null || demoDistrict === undefined ? (
      message
    ) : (
      <DemoDistrictPage
        demoDistrictData={demoDistrict}
        createOrResetDemoDistrict={() =>
          alert('This feature is not yet supported for external demo accounts.')
        }
      />
    )

  // If a search is active, reload the results every fifteen seconds
  React.useEffect(() => {
    if (activeSearchEmail.length > 0) {
      setMessage(null)
      setIsFetching(true)

      const search = () => {
        fetchExternalDemoDistrict(activeSearchEmail)
          .then(res => {
            setIsFetching(false)
            setDemoDistrict(parseDemoDistrict(res))
          })
          .catch(err => {
            setIsFetching(false)
            if (err.status === 404) {
              create()
            } else {
              setMessage('Invalid email address')
            }
          })
      }

      const create = () => {
        createExternalDemoDistrict(activeSearchEmail)
          .then(search)
          .catch(() => {
            setIsFetching(false)
            setMessage(`Unable to create demo account for ${activeSearchEmail}`)
          })
      }

      // Search now, then set up a refresh interval for every 15s
      search()
      const interval = setInterval(search, 15000)
      return () => clearInterval(interval)
    }
  }, [activeSearchEmail])

  return (
    <>
      <hr />
      <div className={demoAccountSearch}>Other account credentials</div>
      <form className={formInline} onSubmit={onSubmit}>
        <input
          type="text"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          disabled={isFetching}
          className={formInput}
        />{' '}
        <Button
          type="submit"
          disabled={isFetching === true}
          onClick={onSubmit}
          addClass={findCreateButton}
        >
          {isFetching === true ? 'Searching...' : 'Find or create'}
        </Button>
      </form>
      {demoDistrictStatus}
    </>
  )
}
